/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * @example
 *  const efficientFunc = debounce(function() { ... }, 100, false)
 *
 * @param func {Function} Callback function
 * @param wait {Number} Wait given milliseconds
 * @param immediate {Boolean} The function on the leading edge
 *
 * @returns {Function} Efficient function
 */
export function debounce(func, wait = 100, immediate = false) {
	let timeout

	return function() {
		const context = this
		const args = arguments
		const later = () => {
			timeout = null
			if (!immediate) func.apply(context, args)
		}
		const callNow = immediate && !timeout
		clearTimeout(timeout)
		timeout = setTimeout(later, wait)
		if (callNow) func.apply(context, args)
	}
}
